import script from "./TableCellViewFlowBite.vue?vue&type=script&setup=true&lang=js"
export * from "./TableCellViewFlowBite.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__